import gql from 'graphql-tag';

export const IndividualListGQL = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $sort: String!
    $page: Int!
    $size: Int!
    $search: String!
  ) {
    audience {
      list(instId: $inst_id, accountId: $account_id, id: $id) {
        attributes
      }
      listAudienceMembers(
        instId: $inst_id
        accountId: $account_id
        id: $id
        sort: $sort
        page: $page
        size: $size
        search: $search
      ) {
        profiles {
          fullName
          userKeyConsolidated
          id
          firstName
          lastName
          relativeInterestLevel
          major
          visitorType
          enrollTerm
          enroll: enrollYear
          lastActive: lastDateActiveWithInstitution
          hasScheduledVisitAllTime
          hasAppliedAllTime
          lastDateActiveWithYouvisit
          city: city
          state: state
          country: country
          gender
          ethnicity
          dateOfBirth: birthDate
          sat
          act
          gpa
          phone
          email
          currentSchool
          postal
          dateRegistered
          levelOfStudy
        }
        page
        totalPages
        totalRecords
        prevPage
        nextPage
      }
    }
  }
`;

export const CreatorPrefGQL = gql`
  query ($inst_id: String!, $account_id: String!, $target_account_id: String) {
    userPrefs(
      instId: $inst_id
      accountId: $account_id
      targetAccountId: $target_account_id
    ) {
      name
      value
      category
      id
      createdAt
      updatedAt
      deletedAt
      instId
    }
  }
`;

export const CurrentUserPrefGQL = gql`
  query ($inst_id: String!, $account_id: String!) {
    userPrefs(instId: $inst_id, accountId: $account_id) {
      name
      value
      category
      id
      createdAt
      updatedAt
      deletedAt
      instId
    }
  }
`;

export const UserPrefsCreate = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $name: String!
    $value: String!
    $category: String!
  ) {
    userPrefsCreate(
      instId: $inst_id
      accountId: $account_id
      name: $name
      value: $value
      category: $category
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;

export const UserPrefsUpdate = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $name: String!
    $value: String!
    $category: String!
    $id: String!
  ) {
    userPrefsUpdate(
      instId: $inst_id
      accountId: $account_id
      name: $name
      value: $value
      category: $category
      id: $id
    ) {
      data {
        instId
        name
        value
        category
        createdAt
        updatedAt
        deletedAt
        id
      }
      message
      code
    }
  }
`;
